"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m7.4626 2 3.6127 5.4864-1.1722 1.7801-2.4405-3.7063-3.1183 4.7356 3.1183 4.7356 1.664-2.527 1.1722 1.7801-2.8362 4.3071L2 10.2958 7.4626 2z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.0662 8.2615-.2202.6578c-.0986.2949-.2946.55-.5323.684-.1988.1123-.5304.2015-1.094-.0059l-.7656-.2817-1.497 2.2676.5632.5314c1.0943 1.0325 1.5981 2.0751 1.5981 3.0839 0 .9625-.4498 1.7507-1.5944 2.8307l-.6114.5769 1.8849 2.3999.7097-.2701c.4786-.182 1.0936-.1974 1.6816-.0746.6219.13.9922.365 1.0835.4689l.7636.8697.7636-.8697c.0902-.1028.4942-.354 1.1336-.4927.6191-.1342 1.1542-.0947 1.4618.0584l.8413.4184 1.5806-2.5707-.5452-.5144c-.5434-.5127-.86-.9554-1.048-1.3791-.1866-.421-.2703-.8774-.2703-1.4516 0-1.0433.4421-2.0766 1.5046-3.0792L22 11.6079l-1.3879-2.2864-.7842.2703c-.614.2117-.9178.1076-1.0783.0121-.2093-.1244-.4016-.3747-.5393-.727l-.2404-.6154h-3.9037zm.2638 2.9636c.4879-.2754.8516-.6634 1.104-1.0767h1.2158c.2378.3896.5738.7747 1.0442 1.0544.4692.2792 1.0091.4165 1.6029.3975-.8796 1.0965-1.3315 2.3081-1.3315 3.5983 0 .7576.112 1.4755.4259 2.1836.2054.4632.4869.8987.8476 1.3241-.6083-.08-1.2248-.0217-1.7486.0918-.4906.1064-1.0094.2856-1.4531.5325-.431-.2391-.9332-.4101-1.421-.512-.6342-.1325-1.3686-.1755-2.0913-.0435l-.0041-.0052c.964-1.0403 1.5856-2.1455 1.5856-3.5713 0-1.3076-.5232-2.5163-1.4068-3.5926.6004.0248 1.1522-.111 1.6304-.3809z"
  })];
};

exports.default = _default;